module.exports = __webpack_public_path__ + "b7643f9505b4b8f8532d47d81c03da2f.MP3";